// extracted by mini-css-extract-plugin
export default {"disable-transition":"Guestbook_disable-transition__5jzsO"};